export const sectors = [
    'general',
    'specific',
];

export const multiple_labels = [
    'application_photos',
    'application_company_logo',
];